export default "__VITE_ASSET__CNofLDlu__"